// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog-module--wrapper--3_10r"};